export const environment = {
    production: true,
    apiUrl: 'https://projects.furnocte.fr:8091',
    authUrl: 'https://projects.furnocte.fr:8100'
};
